

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapActions, mapState } from 'vuex';
import { mixins } from 'vue-class-component';
import { IViewMixin } from '@/mixins/IViewMixin';

@Component({
  name: 'GUserAvator',
  computed: { ...mapState(['account']) },
  methods: { ...mapActions(['signout']) },
})
export default class GUserAvator extends mixins(IViewMixin) {
  isShowSignout: boolean = false;

  mounted() {}

  handleSignout() {
    this.isShowSignout = true;
    this.$Modal.confirm({
      title: this.$t('LOGOUT').toString(),
      content: this.$t('CONFIRM_CONTENT_TEXT').toString(),
      onOk: () => {
        this.$store.dispatch('signout');
      },
    });
  }
}
